import uuid from "uuid";
export default class WorkflowGroupNodeDomainService {
    /**
     * @deprecated this is kinda a hack to save us from an API call.  Use with caution.
     * We might want to change this in the future to load in the actual value.
     */
    static get ExportWorkflowNodeDefinitionType() {
        return {
            id: "Export",
            displayName: "Export",
            description: "Export fields to other nodes",
            icon: "envelope",
            secondaryIcon: "",
        };
    }
    /**
     * @deprecated we need to make this more type-safe in the future. Consider a refactor
     * before extensively using.
     */
    static create({ workflowNodeName, rollupNoun, rollupVerb, statsEnabled, order, workflowNodeType, criteria, userVisible, }) {
        const id = uuid.v4();
        return {
            id,
            description: "",
            workflowNodeName,
            rollupNoun,
            rollupVerb,
            workflowNodeUuid: id,
            statsEnabled: statsEnabled !== null && statsEnabled !== void 0 ? statsEnabled : false,
            order,
            nodeType: workflowNodeType,
            criteria,
            userVisible,
            references: [],
        };
    }
}
